import React from "react";

function Terms() {
  
  return (
    <section className="terms-section section-padding">
      <div className="container">
        <h2 className="mb-4">Общи условия и политики – Botanicheska 302</h2>

        <div className="mb-5">
          <h4 className="mb-3">1. Политика за поверителност и бисквитки</h4>

          <p>
            Botanicheska 302 използва бисквитки, които са важни за правилната
            работа на сайта и предоставяне на персонализирана функционалност.
            Посещавайки уебсайта, Вие се съгласявате с използването им.
            Бисквитките са малки текстови файлове, които се съхраняват във Вашия
            браузър и позволяват разпознаване на потребителя, запазване на
            сесии, поддържане на настройки и оптимизиране на услугите.
            Използваме както сесийни бисквитки (които се изтриват при затваряне
            на браузъра), така и постоянни бисквитки (които се съхраняват за
            определен период). Чрез тях се събира анонимна информация за
            поведението на потребителите с цел анализ и подобрение на
            съдържанието. Данните, които се събират чрез бисквитки и лог
            файлове, включват IP адрес, тип устройство, версия на браузъра,
            операционна система, посещавани страници, както и дата и час на
            достъп. Те се използват за осигуряване на сигурност, изготвяне на
            статистики, измерване на ефективността на маркетинг кампании и за
            ремаркетинг чрез Google Ads и Facebook Pixel. Използваме и
            допълнителни услуги като Google Marketing Services и Facebook Social
            Plugins, чрез които се показват персонализирани реклами и се измерва
            тяхната ефективност. Събираната информация е напълно анонимна и не
            позволява пряка идентификация. Данните се съхраняват за ограничен
            период: сесийните бисквитки до затваряне на браузъра, маркетинговите
            до 6 месеца, а логовете на сървъра до 7 дни, освен ако не възникне
            инцидент. Вие имате право на достъп, корекция или изтриване на
            личните си данни, както и да подадете възражение срещу тяхната
            обработка, да ограничите обработването, да оттеглите съгласието си
            по всяко време или да подадете жалба до Комисията за защита на
            личните данни (КЗЛД). Повече информация можете да откриете на{" "}
            <a
              href="https://www.youronlinechoices.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.youronlinechoices.com
            </a>{" "}
            или като се свържете с нас по имейл:{" "}
            <a href="mailto:sales@botanicheska.com">
              sales@botanicheska.com
            </a>
            .
          </p>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">2. Общи условия</h4>

          <p>
            Сайтът <strong>botanicheska.com</strong> е собственост на{" "}
            <strong>ВЮ ИНВЕСТ (VIEW INVEST)</strong>, регистрирана фирма с
            ЕИК/ПИК: 202458393.
          </p>

          <ul>
            <li>
              <strong>Регистрация по ЗДДС:</strong> Да – BG202458393 от
              15.08.2013 г., на основание чл. 96 от ЗДДС.
            </li>
            <li>
              <strong>Дата на регистрация:</strong> 26.02.2013 г. в 12:46 ч.
            </li>
            <li>
              <strong>Услуги:</strong> Продажба на имоти – апартаменти, студиа,
              офиси и магазини в сграда Botanicheska 302.
            </li>
            <li>
              <strong>Поръчки:</strong> Резервация на имота се извършва срещу депозит. Остатъкът от договорената сума се заплаща при подписване на предварителен договор между страните.
            </li>
            <li>
              <strong>Ограничения:</strong> Забранява се копиране и използване
              на съдържание без писмено съгласие.
            </li>
            <li>
              <strong>Право:</strong> Всички спорове по тълкуването, изменението, изпълнението и прекратяването на настоящия договор ще бъдат решавани чрез споразумение меду страните, а при невъзможност за такова - пред компетентния съд в гр.Варна. За неуредениете в настоящия договор случаи се прилагат разпоредбите на действащото българско законодателство.
            </li>
            <li>
              <strong>Промени:</strong> Botanicheska 302 може да актуализира
              условията. Всички промени ще бъдат публикувани на сайта.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">3. Политика за обработка на заявка </h4>

          <p>
            Всички договори и запитвания се обработват в рамките на 2–3 работни
            дни. Предоставянето на документацията и комуникацията се извършва
            онлайн или на място в офиса на инвеститора.
          </p>

          <ul>
            <li>
              <strong>Доставка на документи:</strong> Чрез имейл или лично
              предаване.
            </li>
            <li>
              <strong>Обхват:</strong> Само на територията на България.
            </li>
            <li>
              <strong>Проблеми:</strong> При неуспешна доставка, клиентът следва
              да се свърже незабавно с нас, за да бъде извършено повторно
              изпращане или корекция.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">4. Политика за отказ</h4>

          <p>
            Отказ от сделка е възможен в рамките на 14 дни от подписване на
            предварителен договор, при условие че не е извършено нотариално
            изповядване.
          </p>

          <ul>
            <li>
              <strong>Условия:</strong> Отказът е валиден само ако не са
              извършени правни действия. Клиентът носи отговорност за всички
              такси, свързани с възстановяването.
            </li>
            <li>
              <strong>Процедура:</strong> Заявка чрез имейл, последвана от
              писмено потвърждение от страна на Botanicheska 302 и
              възстановяване на суми по банков път.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">5. Политика за отказ от поръчка</h4>

          <p>
            Клиентът има право да откаже направена резервация без санкции в
            рамките на 24 часа от подаването ѝ. Отказът може да бъде заявен по
            имейл или чрез телефонно обаждане. При вече извършено авансово
            плащане, възстановяването на сумата се извършва в срок от 7 до 10
            работни дни.
          </p>

          <ul>
            <li>
              <strong>Срок:</strong> До 24 часа след подадена заявка за
              резервация, без санкции.
            </li>
            <li>
              <strong>Начин:</strong> Чрез имейл или телефонно обаждане.
            </li>
            <li>
              <strong>Възстановяване:</strong> В рамките на 7–10 работни дни.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">6. Контакти</h4>

          <p>
            <strong>Адрес:</strong> България, гр. Варна, район Младост, ул. Поп
            Димитър 12, етаж 2
          </p>
          <p>
            <strong>Имейл:</strong>{" "}
            <a href="mailto:sales@botanicheska.com">
              sales@botanicheska.com
            </a>
          </p>
          <p>
            <strong>Уебсайт:</strong>{" "}
            <a
              href="https://www.botanicheska.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.botanicheska.com
            </a>
          </p>
          <p>
            <strong>Страница за контакт:</strong>{" "}
            <a href="/innerpages/contact">/innerpages/contact</a>
          </p>
        </div>

        <div className="mb-4">
          <small>
            * Потвърждавайки поръчката си, вие декларирате, че сте запознати и
            съгласни с Общите условия и Политиката за поверителност.
          </small>
        </div>

        <div className="mb-4">
          <small>
            * Потвърждавайки поръчката си, вие декларирате, че сте запознати и
            съгласни с Общите условия и Политиката за поверителност.
          </small>
        </div>
        <div className="mb-5">
          <h4 className="mb-3">7. Политика за плащане</h4>

          <p>
            Покупката на имот в Botanicheska 302 се осъществява чрез
            предварителен договор, последван от нотариално изповядване.
            Плащанията се извършват по банков път към посочена в договора
            сметка.
          </p>

          <ul>
            <li>
              <strong>Аванс:</strong> 50% от стойността на имота – при
              подписване на предварителен договор.
            </li>
            <li>
              <strong>Остатък:</strong> 50% – при нотариално изповядване.
            </li>
            <li>
              <strong>Допълнителни такси:</strong> Нотариалните и
              административните разходи се поемат от купувача, освен ако не е
              уговорено друго.
            </li>
          </ul>

          <p>
            Всички разходи и срокове се уточняват в предварителния договор,
            включително евентуални такси за удостоверения, документи или банкови
            преводи.
          </p>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">8. Политика за резервации</h4>

          <p>
            Резервацията на апартамент в Botanicheska 302 се счита за валидна
            след писмено потвърждение от страна на инвеститора и след извършено
            авансово плащане от страна на клиента.
          </p>

          <ul>
            <li>
              <strong>Резервационен срок:</strong> До 14 календарни дни без
              подписан договор.
            </li>
            <li>
              <strong>Потвърждение:</strong> Изпраща се по имейл с всички
              конкретни условия и срокове.
            </li>
            <li>
              <strong>Изтичане на резервация:</strong> При неспазване на срока
              за договор, имотът се освобождава и става отново наличен за
              продажба.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">9. Политика за използване на сайта</h4>

          <p>
            Сайтът предоставя информация с представителна и информативна цел.
            Botanicheska 302 си запазва правото да прави промени в съдържанието
            по всяко време и без предварително уведомление.
          </p>

          <ul>
            <li>
              <strong>Информация:</strong> Не представлява оферта по смисъла на
              закона.
            </li>
            <li>
              <strong>Снимки и визуализации:</strong> Имат илюстративен характер
              и е възможно да не отразяват напълно крайния вид на проекта.
            </li>
            <li>
              <strong>Отговорност:</strong> Botanicheska 302 не носи отговорност
              за временна недостъпност на сайта, технически грешки или
              неточности в информацията.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">10. Промени в архитектурния проект</h4>

          <p>
            Botanicheska 302 си запазва правото да прави минимални архитектурни
            и функционални корекции в проекта, когато това е необходимо, без
            това да води до съществена промяна в условията по договора.
          </p>

          <ul>
            <li>
              Промените се извършват в съответствие със строителните нормативи и
              технически изисквания.
            </li>
            <li>
              Клиентите ще бъдат своевременно информирани за всички промени,
              които пряко засягат техните имоти.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">11. Такси и допълнителни разходи</h4>

          <p>
            Освен стойността на имота, купувачът следва да поеме и следните
            разходи, освен ако не е договорено друго между страните:
          </p>

          <ul>
            <li>
              Нотариални такси и държавни такси при изповядване на сделката
            </li>
            <li>Такса за вписване в Имотния регистър</li>
            <li>Такса за издаване на удостоверения и документи</li>
            <li>Банкови такси при превод на суми</li>
          </ul>

          <p>
            Всички разходи се уточняват и посочват подробно в предварителния
            договор, с цел пълна прозрачност за клиента.
          </p>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">12. Гаранции и срок за предаване</h4>

          <p>
            Botanicheska 302 предоставя законово установени гаранции съгласно
            Наредба №2 от 2003 г. за въвеждане в експлоатация на строежите.
          </p>

          <ul>
            <li>
              <strong>Гаранция за строителство:</strong> 5 години
            </li>
            <li>
              <strong>Гаранция за инсталации:</strong> 3 години
            </li>
            <li>
              <strong>Срок за предаване:</strong> Посочва се в договора, в
              зависимост от текущия етап на строителство
            </li>
          </ul>

          <p>
            При предаване на имота се подписва приемо-предавателен протокол,
            след което се предоставят ключовете и необходимата документация.
          </p>
        </div>

        <div className="mb-5">
          <h4 className="mb-3">13. Условия за предаване на имота</h4>
          <p>
            След нотариално изповядване на сделката и изплащане на пълната сума,
            имотът се предава на купувача във вид, описан в договора.
          </p>
          <ul>
            <li>Предаването се извършва чрез приемо-предавателен протокол</li>
            <li>Клиентът се уведомява минимум 5 работни дни предварително</li>
            <li>Преди предаване се извършва оглед и подписване на документи</li>
          </ul>
        </div>
        <div className="mb-5">
          <h4 className="mb-3">14. Контрол и надзор</h4>
          <p>
            Строителството на Botanicheska 302 се извършва под постоянен
            строителен и технически надзор от лицензирани специалисти.
          </p>
          <ul>
            <li>Контрол на материали, технологии и съответствие с проекта</li>
            <li>Документиране на всички фази на строителството</li>
            <li>Съответствие с разрешение за строеж и действащи нормативи</li>
          </ul>
        </div>
        <div className="mb-5">
          <h4 className="mb-3">15. Поддръжка на общите части</h4>
          <p>
            След въвеждане в експлоатация на сградата, се сключва договор с
            избран поддържащ орган (домоуправител или фирма), който отговаря за
            редовната поддръжка на общите части.
          </p>
          <ul>
            <li>
              Сумите за поддръжка се определят според квадратурата на
              притежавания имот
            </li>
            <li>
              Поддръжката включва почистване, осветление, асансьори,
              видеонаблюдение и др.
            </li>
            <li>
              Собствениците са длъжни да участват в общите разноски на етажната
              собственост
            </li>
          </ul>
        </div>
        <div className="mb-5">
          <h4 className="mb-3">16. Политика при забавяне на плащане</h4>
          <p>
            При забавяне на дължими суми по договора, се начисляват законни
            лихви за просрочие, освен ако страните не са договорили друго.
          </p>
          <ul>
            <li>При просрочие над 10 дни – изпращане на официално напомняне</li>
            <li>
              При просрочие над 30 дни – възможност за прекратяване на договора
            </li>
            <li>
              Възстановяване на авансите се извършва при приспадане на дължимите
              санкции
            </li>
          </ul>
        </div>
        <div className="mb-5">
          <h4 className="mb-3">17. Довършителни работи по избор на клиента</h4>
          <p>
            Клиентите могат да заявят изпълнение на довършителни работи спрямо
            лични предпочитания, при условие че това е допустимо спрямо етапа на
            строителство.
          </p>
          <ul>
            <li>Избор на материали за под, стени, врати и санитария</li>
            <li>
              Промени в разпределенията се приемат само при възможност и
              одобрение от технически надзор
            </li>
            <li>
              Изпълнението на индивидуални изисквания се калкулира отделно
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Terms;
